/**
 * Workout verifications – one vote per user per workout. Document id: workoutId_userId.
 */
import { doc, setDoc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'workoutVerifications';

function docId(workoutId, userId) {
  return `${workoutId}_${userId}`;
}

export function verificationRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  /** Add a verification (one per user per workout). Fails if already verified. */
  async function add(workoutId, userId) {
    const id = docId(workoutId, userId);
    const ref = doc(firestore, COLLECTION, id);
    const snap = await getDoc(ref);
    if (snap.exists()) return { added: false, alreadyVerified: true };
    await setDoc(ref, {
      workoutId,
      userId,
      createdAt: new Date(),
    });
    return { added: true };
  }

  /** Check if the given user has verified the given workout. */
  async function hasUserVerified(workoutId, userId) {
    if (!userId) return false;
    const ref = doc(firestore, COLLECTION, docId(workoutId, userId));
    const snap = await getDoc(ref);
    return snap.exists();
  }

  /** Get set of workout IDs that this user has verified (from a list of workout IDs). */
  async function getVerifiedWorkoutIdsByUser(userId, workoutIds) {
    if (!userId || workoutIds.length === 0) return new Set();
    const q = query(coll(), where('userId', '==', userId));
    const snap = await getDocs(q);
    const set = new Set();
    snap.forEach((d) => {
      const wid = d.data().workoutId;
      if (workoutIds.includes(wid)) set.add(wid);
    });
    return set;
  }

  return {
    add,
    hasUserVerified,
    getVerifiedWorkoutIdsByUser,
  };
}

export const verificationRepo = verificationRepository();
